import { black, orange, textMuted } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import styled from 'styled-components'

// Warm tan dash used by the flight path — same decorative hairline colour as the
// itinerary timeline dashes.
const PATH_DASH = '#ebc9a8'

/** One flight row: codes + dashed path + right meta (design `.bento-flight-row`). */
export const FlightRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
`

/** Big origin/destination airport code (design `.trip-airport` at tile size). */
export const AirportCode = styled.span`
	font-family: ${fontDisplay};
	font-weight: 900;
	font-size: 21px;
	letter-spacing: -0.01em;
	color: ${black};
	line-height: 1;
	flex-shrink: 0;
`

/** The dashed path between codes, plane glyph in the middle. */
export const FlightPath = styled.span`
	flex: 1;
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 40px;
	color: ${orange};
`

export const FlightDashes = styled.span`
	flex: 1;
	border-top: 2px dashed ${PATH_DASH};
`

/** Right-aligned meta block; both lines kept on ONE line via nowrap. */
export const FlightMeta = styled.span`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 1px;
	margin-left: 10px;
	flex-shrink: 0;
	min-width: 96px;
`

export const FlightCode = styled.span`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 13.5px;
	color: ${black};
	white-space: nowrap;
`

export const FlightMetaCaption = styled.span`
	font-family: ${fontBody};
	font-size: 12.5px;
	color: ${textMuted};
	white-space: nowrap;
`
